// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA2-Vm5Sty5BPSulmeuAjB4ratuwCaqGVc",
    authDomain: "yido-game1.firebaseapp.com",
    projectId: "yido-game1",
    storageBucket: "yido-game1.firebasestorage.app",
    messagingSenderId: "1085062745257",
    appId: "1:1085062745257:web:82111d528309dc48ad6db8",
    measurementId: "G-D4K59F66JR"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);